import * as authApi from "../api/auth";
import { baseUrl } from "../config/api-config.js";

import {
  auth as actionType,
  handleAxiosError,
} from "../config/action-config.js";
import axios from "axios";
import { errorAlert } from "./alert";

export const getUser = (token) => async (dispatch) => {
  try {
    dispatch({ type: actionType.SUSPENSE });
    const { data } = await authApi.fetchTokenUser(token);
    dispatch({
      type: actionType.FETCH_SUCCESS,
      payload: { ...data, token },
    });
  } catch (error) {

    localStorage.clear();
    sessionStorage.clear();
    dispatch({ type: actionType.LOGOUT, payload: null });
    window.location.reload();
    // handleAxiosError(error);
    // dispatch({
    //   type: actionType.FETCH_FAILURE,
    //   payload: { message: "Please Try Login Again" },
    // });
  }
};
export const loginWithEmail =
  ({ email, password }) =>
  async (dispatch) => {
    try {
      const { data } = await authApi.emailLogin(email, password);
      if (data.status) {
        if (!data.mfa) {
          if(data.first_login === "Y") {
            const email = data.email; 
            const path = "/reset-password"; 
            const url = `${window.location.origin}${path}?email=${encodeURIComponent(email)}`; 
            window.location.replace(url);
          } 
          else {
          localStorage.setItem("token", data.token);
          dispatch({ type: actionType.LOGIN_SUCCESS, payload: data });
          window.location.replace(window.location.origin + "/transaction-list");
              }
        } else {
          sessionStorage.setItem("email", data.email);
          window.location.replace(window.location.origin + "/verify-mfa");
        }
      } else {
        alert(data.msg);
      }
    } catch (error) {
      const res = error.response?.data;
      dispatch({
        type: actionType.LOGIN_FAILURE,
        payload: res?.error || error.message,
      });
    }
  };

export const logout = () => async (dispatch) => {
  localStorage.removeItem("token");
  dispatch({ type: actionType.LOGOUT });
};

export const microsoftLogin = () => (dispatch) => {
  dispatch({ type: actionType.SUSPENSE });
  window.location.replace(`${baseUrl}/auth/outlook`);
};

export const microsoftCallback = (query) => async (dispatch) => {
  try {
    const { data } = await authApi.microsoftCallback(query);
    dispatch({ type: actionType.LOGIN_SUCCESS, payload: data });
  } catch (error) {
    const res = error.response?.data;
    dispatch({
      type: actionType.LOGIN_FAILURE,
      payload: res?.error || error.message,
    });
  }
};

export const teamsCallback = (query) => async (dispatch) => {
  try {
    const { data } = await authApi.teamsCallback(query);

    dispatch({
      type: actionType.UPDATE_SUCCESS,
      payload: { msTeamsAuth: data.token },
    });
    window.location.replace(window.location.origin + "/meetings/new");
  } catch (error) {
    dispatch(errorAlert("Some Error Occured. Please Try again later."));
  }
};
